namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_echarts, {

		background: {
			color: $mol_theme.card,
		},

		Filters_add: {
			width: 'fit-content',
		},

		Content_scroll: {
			overflow: 'hidden',
		},

	} )

}
